import './BasketPage.scss';

export const BasketPage = () => {
  return (
    <section className="basket">
      <div>BasketPage</div>
      <div>BasketPage</div>
      <div>BasketPage</div>
      <div>BasketPage</div>
      <div>BasketPage</div>
      <div>BasketPage</div>
      <div>BasketPage</div>
      <div>BasketPage</div>
    </section>
  );
};